import React from 'react'

function ListSectionTitle({ type, handleTitleClick, open }) {
    const titles = {
        roomtemp: 'En rayon',
        fridge: 'Produits frais',
        freezer: 'Congelés'
    }

    return (
        <h2 className={`title listSection__title ${open ? 'listSection__title--open' : ''}` } onClick={() => handleTitleClick(!open)}>{titles[type]}</h2>
    )
}

export default ListSectionTitle
